function getConnectedContainer(map) {
  if (!map || typeof map.getContainer !== 'function') return null;

  try {
    const container = map.getContainer();
    return container && container.isConnected !== false ? container : null;
  } catch (_error) {
    return null;
  }
}

export function stopMapMotion(map) {
  if (!map || typeof map.stop !== 'function') return;

  try {
    map.stop();
  } catch (_error) {
    // O Leaflet pode já ter removido o container durante a troca de módulo.
  }
}

export function setMapViewSafely(map, center, zoom) {
  if (!getConnectedContainer(map) || !Array.isArray(center) || center.length < 2) return false;

  try {
    stopMapMotion(map);
    map.setView(center, zoom, { animate: false });
    return true;
  } catch (_error) {
    return false;
  }
}

export function fitMapBoundsSafely(map, bounds, options = {}) {
  if (!getConnectedContainer(map) || !Array.isArray(bounds) || bounds.length === 0) return false;

  try {
    stopMapMotion(map);
    map.fitBounds(bounds, { ...options, animate: false });
    return true;
  } catch (_error) {
    return false;
  }
}
